import React from 'react';

export interface IconProps {
  color?: string;
  width?: number | string;
  height?: number | string;
}

export const SquareIcon: React.FC<IconProps> = ({ color = '#4B5565' }) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.9999 3.33398H4.99992C4.08325 3.33398 3.33325 4.08398 3.33325 5.00065V15.0007C3.33325 15.9173 4.08325 16.6673 4.99992 16.6673H14.9999C15.9166 16.6673 16.6666 15.9173 16.6666 15.0007V5.00065C16.6666 4.08398 15.9166 3.33398 14.9999 3.33398ZM14.9999 15.0007H4.99992V5.00065H14.9999V15.0007Z"
        fill={color}
      />
    </svg>
  );
};

export const BoundingBoxIcon: React.FC<IconProps> = ({ color = '#4B5565' }) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_2959_73)">
        <mask id="mask0_2959_73" maskUnits="userSpaceOnUse" x="1" y="1" width="18" height="18">
          <path d="M1 1H18.4V18.4H1V1Z" fill="white" />
        </mask>
        <g mask="url(#mask0_2959_73)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.86188 1C2.86958 1 2.87729 1 2.88501 1H4.91501C4.92272 1 4.93043 1 4.93813 1C5.12111 0.99998 5.29931 0.999959 5.45022 1.01229C5.61595 1.02583 5.81151 1.05778 6.00829 1.15804C6.28112 1.29706 6.50295 1.51888 6.64196 1.79171C6.74223 1.9885 6.77418 2.18406 6.78772 2.34979C6.80005 2.5007 6.80003 2.6789 6.80001 2.86188C6.80001 2.86958 6.8 2.87729 6.8 2.88501V3.17501H12.6V2.86189C12.6 2.67891 12.5999 2.50071 12.6123 2.34979C12.6258 2.18406 12.6578 1.9885 12.758 1.79171C12.897 1.51888 13.1189 1.29706 13.3917 1.15804C13.5885 1.05778 13.7841 1.02583 13.9498 1.01229C14.1007 0.999959 14.2789 0.99998 14.4619 1H16.5381C16.7211 0.99998 16.8993 0.999959 17.0502 1.01229C17.2159 1.02583 17.4115 1.05778 17.6083 1.15804C17.8811 1.29706 18.103 1.51888 18.2419 1.79171C18.3422 1.9885 18.3742 2.18406 18.3877 2.34979C18.4001 2.5007 18.4 2.67889 18.4 2.86187V4.93814C18.4 5.12112 18.4001 5.29931 18.3877 5.45022C18.3742 5.61595 18.3422 5.81151 18.2419 6.00829C18.103 6.28112 17.8811 6.50295 17.6083 6.64196C17.4115 6.74223 17.2159 6.77418 17.0502 6.78772C16.8993 6.80005 16.7211 6.80003 16.5381 6.80001L16.225 6.8V12.6H16.5381C16.7211 12.6 16.8993 12.5999 17.0502 12.6123C17.2159 12.6258 17.4115 12.6578 17.6083 12.758C17.8811 12.897 18.103 13.1189 18.2419 13.3917C18.3422 13.5885 18.3742 13.7841 18.3877 13.9498C18.4001 14.1007 18.4 14.2789 18.4 14.4619V16.5381C18.4 16.7211 18.4001 16.8993 18.3877 17.0502C18.3742 17.2159 18.3422 17.4115 18.2419 17.6083C18.103 17.8811 17.8811 18.103 17.6083 18.2419C17.4115 18.3422 17.2159 18.3742 17.0502 18.3877C16.8993 18.4001 16.7211 18.4 16.5381 18.4H14.4619C14.2789 18.4 14.1007 18.4001 13.9498 18.3877C13.7841 18.3742 13.5885 18.3422 13.3917 18.2419C13.1189 18.103 12.897 17.8811 12.758 17.6083C12.6578 17.4115 12.6258 17.2159 12.6123 17.0502C12.5999 16.8993 12.6 16.7211 12.6 16.5381V16.225H6.8L6.80001 16.5381C6.80003 16.7211 6.80005 16.8993 6.78772 17.0502C6.77418 17.2159 6.74223 17.4115 6.64196 17.6083C6.50295 17.8811 6.28112 18.103 6.00829 18.2419C5.81151 18.3422 5.61595 18.3742 5.45022 18.3877C5.29931 18.4001 5.12112 18.4 4.93814 18.4H2.86187C2.67889 18.4 2.5007 18.4001 2.34979 18.3877C2.18406 18.3742 1.9885 18.3422 1.79171 18.2419C1.51888 18.103 1.29706 17.8811 1.15804 17.6083C1.05778 17.4115 1.02583 17.2159 1.01229 17.0502C0.999959 16.8993 0.99998 16.7211 1 16.5381V14.4619C0.99998 14.2789 0.999959 14.1007 1.01229 13.9498C1.02583 13.7841 1.05778 13.5885 1.15804 13.3917C1.29706 13.1189 1.51888 12.897 1.79171 12.758C1.9885 12.6578 2.18406 12.6258 2.34979 12.6123C2.50071 12.5999 2.67891 12.6 2.86189 12.6H3.17501V6.8H2.88501C2.87729 6.8 2.86958 6.80001 2.86188 6.80001C2.6789 6.80003 2.5007 6.80005 2.34979 6.78772C2.18406 6.77418 1.9885 6.74223 1.79171 6.64196C1.51888 6.50295 1.29706 6.28112 1.15804 6.00829C1.05778 5.81151 1.02583 5.61595 1.01229 5.45022C0.999959 5.29931 0.99998 5.12111 1 4.93813C1 4.93043 1 4.92272 1 4.91501V2.88501C1 2.87729 1 2.86958 1 2.86188C0.99998 2.6789 0.999959 2.5007 1.01229 2.34979C1.02583 2.18406 1.05778 1.9885 1.15804 1.79171C1.29706 1.51888 1.51888 1.29706 1.79171 1.15804C1.9885 1.05778 2.18406 1.02583 2.34979 1.01229C2.5007 0.999959 2.6789 0.99998 2.86188 1ZM4.62501 6.8V12.6H4.93812C5.1211 12.6 5.2993 12.5999 5.45022 12.6123C5.61595 12.6258 5.81151 12.6578 6.00829 12.758C6.28112 12.897 6.50295 13.1189 6.64196 13.3917C6.74223 13.5885 6.77418 13.7841 6.78772 13.9498C6.80005 14.1007 6.80003 14.2789 6.80001 14.4619L6.8 14.775H12.6V14.4619C12.6 14.2789 12.5999 14.1007 12.6123 13.9498C12.6258 13.7841 12.6578 13.5885 12.758 13.3917C12.897 13.1189 13.1189 12.897 13.3917 12.758C13.5885 12.6578 13.7841 12.6258 13.9498 12.6123C14.1007 12.5999 14.2789 12.6 14.4619 12.6H14.775V6.8L14.4619 6.80001C14.2789 6.80003 14.1007 6.80005 13.9498 6.78772C13.7841 6.77418 13.5885 6.74223 13.3917 6.64196C13.1189 6.50295 12.897 6.28112 12.758 6.00829C12.6578 5.81151 12.6258 5.61595 12.6123 5.45022C12.5999 5.2993 12.6 5.1211 12.6 4.93812V4.62501L6.8 4.625V4.91501C6.8 4.92272 6.80001 4.93043 6.80001 4.93813C6.80003 5.12111 6.80005 5.29931 6.78772 5.45022C6.77418 5.61595 6.74223 5.81151 6.64196 6.00829C6.50295 6.28112 6.28112 6.50295 6.00829 6.64196C5.81151 6.74223 5.61595 6.77418 5.45022 6.78772C5.29931 6.80005 5.12111 6.80003 4.93813 6.80001C4.93043 6.80001 4.92272 6.8 4.91501 6.8H4.62501ZM2.4583 2.4583C2.45803 2.46131 2.45775 2.4645 2.45747 2.46786C2.45057 2.55238 2.45001 2.67002 2.45001 2.88501V4.91501C2.45001 5.12998 2.45057 5.24762 2.45747 5.33214C2.45775 5.33551 2.45803 5.3387 2.4583 5.34171C2.46131 5.34198 2.4645 5.34226 2.46786 5.34253C2.55238 5.34944 2.67002 5.35001 2.88501 5.35001H4.91501C5.12998 5.35001 5.24762 5.34944 5.33214 5.34253C5.33551 5.34226 5.3387 5.34198 5.34171 5.34171C5.34198 5.3387 5.34226 5.33551 5.34253 5.33214C5.34944 5.24762 5.35001 5.12998 5.35001 4.91501V2.88501C5.35001 2.67002 5.34944 2.55238 5.34253 2.46786C5.34226 2.4645 5.34198 2.46131 5.34171 2.4583C5.3387 2.45803 5.33551 2.45775 5.33214 2.45747C5.24762 2.45057 5.12998 2.45001 4.91501 2.45001H2.88501C2.67002 2.45001 2.55238 2.45057 2.46786 2.45747C2.4645 2.45775 2.46131 2.45803 2.4583 2.4583ZM14.0583 2.4583C14.058 2.46131 14.0578 2.4645 14.0575 2.46786C14.0506 2.55238 14.05 2.67002 14.05 2.88501V4.91501C14.05 5.12998 14.0506 5.24762 14.0575 5.33214C14.0578 5.33551 14.058 5.33869 14.0583 5.3417C14.0613 5.34197 14.0645 5.34226 14.0678 5.34253C14.1524 5.34944 14.27 5.35001 14.485 5.35001H16.515C16.73 5.35001 16.8476 5.34944 16.9322 5.34253C16.9355 5.34226 16.9387 5.34197 16.9417 5.3417C16.942 5.33869 16.9422 5.33551 16.9425 5.33214C16.9494 5.24762 16.95 5.12998 16.95 4.91501V2.88501C16.95 2.67002 16.9494 2.55238 16.9425 2.46786C16.9422 2.4645 16.942 2.46131 16.9417 2.4583C16.9387 2.45803 16.9355 2.45775 16.9322 2.45747C16.8476 2.45057 16.73 2.45001 16.515 2.45001H14.485C14.27 2.45001 14.1524 2.45057 14.0678 2.45747C14.0645 2.45775 14.0613 2.45803 14.0583 2.4583ZM2.45831 14.0583C2.45803 14.0613 2.45775 14.0645 2.45747 14.0678C2.45057 14.1524 2.45001 14.27 2.45001 14.485V16.515C2.45001 16.73 2.45057 16.8476 2.45747 16.9322C2.45775 16.9355 2.45803 16.9387 2.4583 16.9417C2.46131 16.942 2.4645 16.9422 2.46786 16.9425C2.55238 16.9494 2.67002 16.95 2.88501 16.95H4.91501C5.12998 16.95 5.24762 16.9494 5.33214 16.9425C5.33551 16.9422 5.3387 16.942 5.34171 16.9417C5.34198 16.9387 5.34226 16.9355 5.34253 16.9322C5.34944 16.8476 5.35001 16.73 5.35001 16.515V14.485C5.35001 14.27 5.34944 14.1524 5.34253 14.0678C5.34226 14.0645 5.34197 14.0613 5.3417 14.0583C5.33869 14.058 5.33551 14.0578 5.33214 14.0575C5.24762 14.0506 5.12998 14.05 4.91501 14.05H2.88501C2.67002 14.05 2.55238 14.0506 2.46786 14.0575C2.4645 14.0578 2.46132 14.058 2.45831 14.0583ZM14.0583 14.0583C14.058 14.0613 14.0578 14.0645 14.0575 14.0678C14.0506 14.1524 14.05 14.27 14.05 14.485V16.515C14.05 16.73 14.0506 16.8476 14.0575 16.9322C14.0578 16.9355 14.058 16.9387 14.0583 16.9417C14.0613 16.942 14.0645 16.9422 14.0678 16.9425C14.1524 16.9494 14.27 16.95 14.485 16.95H16.515C16.73 16.95 16.8476 16.9494 16.9322 16.9425C16.9355 16.9422 16.9387 16.942 16.9417 16.9417C16.942 16.9387 16.9422 16.9355 16.9425 16.9322C16.9494 16.8476 16.95 16.73 16.95 16.515V14.485C16.95 14.27 16.9494 14.1524 16.9425 14.0678C16.9422 14.0645 16.942 14.0613 16.9417 14.0583C16.9387 14.058 16.9355 14.0578 16.9322 14.0575C16.8476 14.0506 16.73 14.05 16.515 14.05H14.485C14.27 14.05 14.1524 14.0506 14.0678 14.0575C14.0645 14.0578 14.0613 14.058 14.0583 14.0583Z"
            fill={color}
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_2959_73">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const HandIcon: React.FC<IconProps> = ({ color = '#4B5565' }) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.74996 9.53639V11.8512M5.74996 9.53639V3.98083C5.74996 3.21377 6.38422 2.59194 7.16663 2.59194C7.94903 2.59194 8.58329 3.21377 8.58329 3.98083M5.74996 9.53639C5.74996 8.76932 5.1157 8.1475 4.33329 8.1475C3.55089 8.1475 2.91663 8.76932 2.91663 9.53639V11.3882C2.91663 15.2235 6.08794 18.3327 9.99996 18.3327C13.912 18.3327 17.0833 15.2235 17.0833 11.3882V6.75861C17.0833 5.99155 16.449 5.36972 15.6666 5.36972C14.8842 5.36972 14.25 5.99155 14.25 6.75861M8.58329 3.98083V9.07342M8.58329 3.98083V3.0549C8.58329 2.28784 9.21756 1.66602 9.99996 1.66602C10.7824 1.66602 11.4166 2.28784 11.4166 3.0549V3.98083M11.4166 3.98083V9.07342M11.4166 3.98083C11.4166 3.21377 12.0509 2.59194 12.8333 2.59194C13.6157 2.59194 14.25 3.21377 14.25 3.98083V6.75861M14.25 6.75861V9.07342"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const SmartLabelingIcon: React.FC<IconProps> = ({ color = '#4B5565' }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="mask0_1734_6422" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1734_6422)">
        <path
          d="M20 7L19.05 4.95L17 4L19.05 3.05L20 1L20.95 3.05L23 4L20.95 4.95L20 7ZM8.5 7L7.55 4.95L5.5 4L7.55 3.05L8.5 1L9.45 3.05L11.5 4L9.45 4.95L8.5 7ZM20 18.5L19.05 16.45L17 15.5L19.05 14.55L20 12.5L20.95 14.55L23 15.5L20.95 16.45L20 18.5ZM5.1 21.7L2.3 18.9C2.1 18.7 2 18.4583 2 18.175C2 17.8917 2.1 17.65 2.3 17.45L13.45 6.3C13.65 6.1 13.8917 6 14.175 6C14.4583 6 14.7 6.1 14.9 6.3L17.7 9.1C17.9 9.3 18 9.54167 18 9.825C18 10.1083 17.9 10.35 17.7 10.55L6.55 21.7C6.35 21.9 6.10833 22 5.825 22C5.54167 22 5.3 21.9 5.1 21.7ZM5.85 19.6L13 12.4L11.6 11L4.4 18.15L5.85 19.6Z"
          fill={color}
        />
      </g>
    </svg>
  );
};

export const BrushIcon: React.FC<IconProps> = ({ color = '#4B5565' }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.9999 10.3342L13.6666 7.0009M4.08325 19.9176L6.90356 19.6042C7.24813 19.5659 7.42042 19.5468 7.58146 19.4946C7.72433 19.4484 7.86029 19.383 7.98566 19.3004C8.12696 19.2072 8.24954 19.0846 8.49469 18.8395L19.4999 7.83424C20.4204 6.91376 20.4204 5.42138 19.4999 4.5009C18.5795 3.58043 17.0871 3.58043 16.1666 4.5009L5.16136 15.5061C4.91621 15.7513 4.79363 15.8739 4.70045 16.0152C4.61778 16.1405 4.55243 16.2765 4.50618 16.4194C4.45405 16.5804 4.43491 16.7527 4.39662 17.0973L4.08325 19.9176Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const BrushDrawIcon: React.FC<IconProps> = ({ color = '#4B5565' }) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.9999 8.33424L11.6666 5.0009M2.08325 17.9176L4.90356 17.6042C5.24813 17.5659 5.42042 17.5468 5.58146 17.4946C5.72433 17.4484 5.86029 17.383 5.98566 17.3004C6.12696 17.2072 6.24954 17.0846 6.49469 16.8395L17.4999 5.83424C18.4204 4.91376 18.4204 3.42138 17.4999 2.5009C16.5795 1.58043 15.0871 1.58043 14.1666 2.5009L3.16136 13.5061C2.91621 13.7513 2.79363 13.8739 2.70045 14.0152C2.61778 14.1405 2.55243 14.2765 2.50618 14.4194C2.45405 14.5804 2.43491 14.7527 2.39662 15.0973L2.08325 17.9176Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M13 16H19" stroke={color} strokeWidth="2" />
      <path d="M16 19V13" stroke={color} strokeWidth="2" />
    </svg>
  );
};

export const BrushEraserIcon: React.FC<IconProps> = ({ color = '#4B5565' }) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.9999 8.33424L11.6666 5.0009M2.08325 17.9176L4.90356 17.6042C5.24813 17.5659 5.42042 17.5468 5.58146 17.4946C5.72433 17.4484 5.86029 17.383 5.98566 17.3004C6.12696 17.2072 6.24954 17.0846 6.49469 16.8395L17.4999 5.83424C18.4204 4.91376 18.4204 3.42138 17.4999 2.5009C16.5795 1.58043 15.0871 1.58043 14.1666 2.5009L3.16136 13.5061C2.91621 13.7513 2.79363 13.8739 2.70045 14.0152C2.61778 14.1405 2.55243 14.2765 2.50618 14.4194C2.45405 14.5804 2.43491 14.7527 2.39662 15.0973L2.08325 17.9176Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M13 16H19" stroke={color} strokeWidth="2" />
    </svg>
  );
};

export const PolygonIcon: React.FC<IconProps> = ({ color = '#4B5565' }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="mask0_2000_6779" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_2000_6779)">
        <path
          d="M7.45 19H16.55L19.625 9.775L12 4.45L4.375 9.775L7.45 19ZM6 21L2 9L12 2L22 9L18 21H6Z"
          fill={color}
        />
      </g>
    </svg>
  );
};

export const PolygonDrawIcon: React.FC<IconProps> = ({ color = '#4B5565' }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="mask0_2023_7937" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_2023_7937)">
        <path
          d="M7.45 19H16.55L19.625 9.775L12 4.45L4.375 9.775L7.45 19ZM6 21L2 9L12 2L22 9L18 21H6Z"
          fill={color}
        />
      </g>
      <mask
        id="path-3-outside-1_2023_7937"
        maskUnits="userSpaceOnUse"
        x="14"
        y="10"
        width="8"
        height="8"
        fill="black"
      >
        <rect fill="white" x="14" y="10" width="8" height="8" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19 13V11H17V13H15V15H17V17H19V15H21V13H19Z"
        />
      </mask>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19 13V11H17V13H15V15H17V17H19V15H21V13H19Z"
        fill={color}
      />
      <path
        d="M19 11H20V10H19V11ZM19 13H18V14H19V13ZM17 11V10H16V11H17ZM17 13V14H18V13H17ZM15 13V12H14V13H15ZM15 15H14V16H15V15ZM17 15H18V14H17V15ZM17 17H16V18H17V17ZM19 17V18H20V17H19ZM19 15V14H18V15H19ZM21 15V16H22V15H21ZM21 13H22V12H21V13ZM18 11V13H20V11H18ZM17 12H19V10H17V12ZM18 13V11H16V13H18ZM15 14H17V12H15V14ZM16 15V13H14V15H16ZM17 14H15V16H17V14ZM18 17V15H16V17H18ZM19 16H17V18H19V16ZM18 15V17H20V15H18ZM21 14H19V16H21V14ZM20 13V15H22V13H20ZM19 14H21V12H19V14Z"
        fill="white"
        mask="url(#path-3-outside-1_2023_7937)"
      />
    </svg>
  );
};

export const PolygonEraserIcon: React.FC<IconProps> = ({ color = '#4B5565' }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="mask0_2000_6978" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_2000_6978)">
        <path
          d="M7.45 19H16.55L19.625 9.775L12 4.45L4.375 9.775L7.45 19ZM6 21L2 9L12 2L22 9L18 21H6Z"
          fill={color}
        />
      </g>
      <rect width="8" height="4" transform="translate(15 13)" fill="#E5E5E5" />
      <path d="M16 15H22" stroke={color} strokeWidth="2" />
    </svg>
  );
};

export const PolylineIcon: React.FC<IconProps> = ({ color = '#4B5565' }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="mask0_2000_6783" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_2000_6783)">
        <path
          d="M15 22V19.5L8 16H3V10H7.3L10 6.9V2H16V8H11.7L9 11.1V14.25L15 17.25V16H21V22H15ZM12 6H14V4H12V6ZM5 14H7V12H5V14ZM17 20H19V18H17V20Z"
          fill={color}
        />
      </g>
    </svg>
  );
};

export const UndoIcon: React.FC<IconProps> = ({ color = '#4B5565' }) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.33337 5.83333H11.6667C14.4281 5.83333 16.6667 8.07191 16.6667 10.8333C16.6667 13.5948 14.4281 15.8333 11.6667 15.8333H3.33337M3.33337 5.83333L6.66671 2.5M3.33337 5.83333L6.66671 9.16667"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const RedoIcon: React.FC<IconProps> = ({ color = '#4B5565' }) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.6667 5.83333H8.33337C5.57195 5.83333 3.33337 8.07191 3.33337 10.8333C3.33337 13.5948 5.57195 15.8333 8.33337 15.8333H16.6667M16.6667 5.83333L13.3334 2.5M16.6667 5.83333L13.3334 9.16667"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ClearIcon: React.FC<IconProps> = ({ color = '#F04438' }) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.3333 9.16732H12.5V2.50065C12.5 1.58398 11.75 0.833984 10.8333 0.833984H9.16667C8.25 0.833984 7.5 1.58398 7.5 2.50065V9.16732H6.66667C4.36667 9.16732 2.5 11.034 2.5 13.334V19.1673H17.5V13.334C17.5 11.034 15.6333 9.16732 13.3333 9.16732ZM9.16667 2.50065H10.8333V9.16732H9.16667V2.50065ZM15.8333 17.5006H14.1667V15.0006C14.1667 14.5423 13.7917 14.1673 13.3333 14.1673C12.875 14.1673 12.5 14.5423 12.5 15.0006V17.5006H10.8333V15.0006C10.8333 14.5423 10.4583 14.1673 10 14.1673C9.54167 14.1673 9.16667 14.5423 9.16667 15.0006V17.5006H7.5V15.0006C7.5 14.5423 7.125 14.1673 6.66667 14.1673C6.20833 14.1673 5.83333 14.5423 5.83333 15.0006V17.5006H4.16667V13.334C4.16667 11.959 5.29167 10.834 6.66667 10.834H13.3333C14.7083 10.834 15.8333 11.959 15.8333 13.334V17.5006Z"
        fill={color}
      />
    </svg>
  );
};

export const TuneIcon: React.FC<IconProps> = ({ color = '#4B5565' }) => {
  return (
    <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.66667 15.5V10.5H8.33333V12.1667H15V13.8333H8.33333V15.5H6.66667ZM0 13.8333V12.1667H5V13.8333H0ZM3.33333 10.5V8.83333H0V7.16667H3.33333V5.5H5V10.5H3.33333ZM6.66667 8.83333V7.16667H15V8.83333H6.66667ZM10 5.5V0.5H11.6667V2.16667H15V3.83333H11.6667V5.5H10ZM0 3.83333V2.16667H8.33333V3.83333H0Z"
        fill={color}
      />
    </svg>
  );
};
